import { FieldLocator } from '@app/common/configurable-wizards';
import {
  ComboboxFieldComponent,
} from '@app/common/configurable-wizards/fields/SingleChoice/Combobox/ComboboxFieldComponent';
import { isSingleChoiceField } from '@app/common/configurable-wizards/utils';

export const SingleChoiceFieldInfoFieldLocator: FieldLocator = ({ field }) => (
  isSingleChoiceField(field)
    ? ComboboxFieldComponent
    : undefined
);
